import request from '../../request';

export function productListAPI() {
  return request(
    {
      url: '/api/v1/product/products/',
      method: 'GET',
    },
    false
  );
}

export function smartObjectAPI() {
  return request(
    {
      url: '/api/v1/product/smart-objects-management/',
      method: 'GET',
    },
    true
  );
}


export function servicesListAPI() {
  return request(
    {
      url: '/api/v1/product/services/',
      method: 'GET',
    },
    false
  );
}

